import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DebugInfo from '../../components/DebugInfo';

const Debug = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/profile');
    };

    return (
        <div style={{ 
            minHeight: '100vh', 
            background: '#f5f5f5',
            paddingTop: '20px',
            paddingBottom: '100px' // Space for bottom navigation
        }}>
            <div style={{ 
                maxWidth: '600px', 
                margin: '0 auto',
                padding: '0 15px'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '20px',
                    gap: '10px'
                }}>
                    <Button
                        onClick={handleBack}
                        startIcon={<ArrowBackIcon />}
                        sx={{
                            color: '#333',
                            textTransform: 'none',
                            fontSize: '16px',
                            fontFamily: 'OnestRegular'
                        }}
                    >
                        Back to Profile
                    </Button>
                </div>
                <h1 style={{ 
                    textAlign: 'center', 
                    color: '#333', 
                    marginBottom: '20px',
                    fontSize: '24px'
                }}>
                    🔧 Debug Panel
                </h1>
                <DebugInfo />
            </div>
        </div>
    );
};

export default Debug; 